import { Fragment } from "react";
import { Link } from "react-router-dom";

const faqData = {
    title: {
        en: "Frequently asked questions",
        ka: "ხშირად დასმული კითხვები",
    },
    en: [
    	{
            id: "1",
            title: "Where do the sweets in Captain Candy’s stores come from?", 
            content: "Captain Candy’s ships travel all over Europe (from Spain to Germany, from Sweden to Italy) to the very best suppliers for candy. All you have to do is look at the barrel or the box and that will tell you where the particular candy has sailed from."
        },
        {
            id: "2",
            title: " What is the shelf life of the candy?", 
            content: "As we pirates say, “You can find the answer to everything in a barrel”. In this case not actually in the barrel, but on the barrel. The candy’s shelf life is written on each of them.",
        },
        {
            id: "3",
            title: "How should the candy be stored after it has been bought?", 
            content: "In the same way as supplies on pirate expeditions - if possible in dry and cold conditions",
        },
        {
            id: "4",
            title: "Is it okay that the candy in the stores lies in open barrels?", 
            content: "Although pirates often lived outside the law, everything’s all right here. It’s called “free sale” and doesn’t break hygiene rules in any way. It’s like when you put bread in a bag in a port’s “super” market…",
        },
        {
            id: "5",
            title: "Where does Captain Candy come from?", 
            content: "The first Captain Candy store was opened in Prague and after this success we decided to expand further. You can currently find us in several countries and we are planning more!",
        },
        {
            id: "6",
            title: "Why can’t we try the candy in the barrels?", 
            content: "Unfortunately, it’s not possible for hygiene reasons. But don’t be afraid to ask our crews in the stores – they will be happy to help you find the exact taste you are looking for.",
        },
        {
            id: "7",
            title: "Is it hygienic to put tongs on barrels? ", 
            content: "The old pirate rule states that “tongs belong on a barrel”. What’s more, here too we respect the law which doesn’t see any problem with this.",
        },
        // {
        //     id: "8",
        //     title: "How many stores does Captain Candy have?", 
        //     content: "So far we have dropped anchor in four places in Prague and we have two harbours each in Dubrovnik in Croatia and in Venice in Italy. And we are planning more expeditions!",
        // },
        {
            id: "9",
            title: "Does the Captain Candy concept also work as a franchise?", 
            content: <Fragment>Yes, the Captain Candy concept successfully operates several franchise stores. If you are interested in cooperation, please contact us via the form in the <Link to="/franchising">“Franchising”</Link> section.</Fragment>
        },
        {
            id: "10",
            title: "Are the barrels really completely full?", 
            content: "Pirates must have some secrets. And that’s why we’ll leave it to you to guess.",
        },
        {
            id: "11",
            title: "Which is the most popular candy?", 
            content: "Not even the famous sorceress from the Island of Crystal Balls could answer that. Everyone chooses whatever suits their taste and the best-selling candy often changes. If you look at the barrels in the stores you will find out more.",
        },
        {
            id: "12",
            title: "What are the stores’ opening hours?", 
            content: <Fragment>Each store follows its own opening hours. You can find the details <Link to="/stores">here</Link>.</Fragment>,
        },
        {
            id: "13",
            title: " Why isn’t the price of the candy written on each barrel?", 
            content: " Because there’s no need. ;) The price per 100 g is uniform for the entire selection and you will always find it written in the store.",
        },
    ],
    ka: [
    	{
            id: "1",
            title: "საიდან მოდის ტკბილეული Captain Candy-ის მაღაზიებში?", 
            content: "Captain Candy-ის გემები მთელ ევროპას მოივლიან (ესპანეთიდან გერმანიამდე, შვედეთიდან იტალიამდე) საუკეთესო მომწოდებლების მოსაძებნად. უბრალოდ შეხედეთ კასრს ან ყუთს და მაშინვე გაიგებთ, საიდან მოცურდა კონკრეტული ტკბილეული."
        },
        {
            id: "2",
            title: "რამდენ ხანს ინახება ტკბილეული? ", 
            content: 'როგორც ჩვენ, მეკობრეები, ვამბობთ: "ყველაფრის პასუხს კასრში იპოვი." ამ შემთხვევაში არა პირდაპირ კასრში, არამედ კასარზე. ტკბილეულის ვარგისიანობის ვადა თითოეულზე წერია.',
        },
        {
            id: "3",
            title: "როგორ უნდა შევინახოთ ტკბილეული ყიდვის შემდეგ?", 
            content: "ისევე, როგორც მარაგი მეკობრეთა ექსპედიციებზე — შეძლებისდაგვარად მშრალ და გრილ ადგილას.",
        },
        {
            id: "4",
            title: "ნორმალურია, რომ ტკბილეული მაღაზიებში ღია კასრებში დევს?", 
            content: "მართალია, მეკობრეები ხშირად კანონს არ ემორჩილებოდნენ, აქ ყველაფერი წესრიგშია. ამას „თავისუფალი გაყიდვა“ ჰქვია და არანაირად არ ეწინააღმდეგება ჰიგიენის სტანდარტებს. ეს იგივეა, რაც პორტის ბაზარში პურის პარკში ყიდვა…",
        },
        {
            id: "5",
            title: "საიდან მოდის Captain Candy?", 
            content: "პირველი Captain Candy-ის მაღაზია პრაღაში გაიხსნა და ამ წარმატების შემდეგ გადავწყვიტეთ შემდგომი გაფართოება. ამჟამად რამდენიმე ქვეყანაში გვპოულობთ და კიდევ უფრო მეტს ვგეგმავთ!",   
        },
        {
            id: "6",
            title: "რატომ არ შეიძლება კასრებიდან ტკბილეულის გასინჯვა?", 
            content: "ეს, სამწუხაროდ, ჰიგიენური მიზეზების გამო შეუძლებელია. მაგრამ ნუ მოგერიდებათ პირდაპირ მაღაზიებში ჩვენი გუნდის კითხვა — ისინი სიამოვნებით დაგეხმარებიან ზუსტად იმ გემოს მოძებნაში, რომელსაც ეძებთ.",
        },
        {
            id: "7",
            title: "ჰიგიენურია კასრებზე მარწუხების დადება? ", 
            content: 'ძველი მეკობრული წესი ამბობს, რომ "მარწუხები კასარს ეკუთვნის". უფრო მეტიც, აქაც ვცავთ კანონს, რომელიც ამაში პრობლემას ვერ ხედავს.',
        },
        {
            id: "9",
            title: "მუშაობს თუ არა Captain Candy-ის კონცეფცია ფრანჩაიზის სახითაც?", 
            content: <Fragment>დიახ, Captain Candy-ის კონცეფცია წარმატებით მართავს რამდენიმე ფრანჩაიზის მაღაზიას. თუ თანამშრომლობით ხართ დაინტერესებული, გთხოვთ, დაგვიკავშირდეთ <Link to="/franchising">&quot;ფრანჩაიზინგი&quot;</Link> განყოფილების ფორმის მეშვეობით.</Fragment>,
        },
        {
            id: "10",
            title: "მართლა სავსეა კასრები?", 
            content: "მეკობრეებს უნდა ჰქონდეთ რამდენიმე საიდუმლო და სწორედ ამის გამოცნობას გთავაზობთ :-)",
        },
        {
            id: "11",
            title: "რომელი ტკბილეულია ყველაზე პოპულარული?", 
            content: "ამაზე კრისტალის ბურთების კუნძულის ცნობილ ჯადოქრებსაც კი ვერ უპასუხებიათ. თითოეული თავისი გემოვნებით ირჩევს და ყველაზე გაყიდვადი ტკბილეული ხშირად იცვლება. მეტს გაიგებთ, თუ მაღაზიებში კასრებს ჩახედავთ.",
        },
        {
            id: "12",
            title: "როგორია მაღაზიების სამუშაო საათები?", 
            content: <Fragment>თითოეული მაღაზია საკუთარი მეკობრული პრინციპებით მუშაობს. დეტალები შეგიძლიათ <Link to="/stores">აქ</Link> ნახოთ.</Fragment>,
        },
        {
            id: "13",
            title: "რატომ არ წერია ყველა კასარზე ტკბილეულის ფასი?", 
            content: "იმიტომ, რომ საჭირო არ არის. ;) ფასი 100გ-ზე მთელი ასორტიმენტისთვის ერთიანია და ყოველთვის მითითებულია მაღაზიაში.",
        },
    ],
};

const dataProcessing = {
    en: {
        title: "Personal data processing",
        parag: [
            'To protect my personal data, I consent, as the data subject, to the collection, storage and processing of the following personal data: first name, surname, e-mail address, residential address, date of birth, mobile phone number, education details and other information voluntarily provided in the submitted questionnaire by the data controller: Tresher s.r.o., registered office at Na Maninách 1040/14, Holešovice (Prague 7), 170 00 Prague, company ID 24217280, VAT ID CZ24217280, registered with the Municipal Court in Prague under file no. C 189598 (the “Controller”).',
            "This consent is granted for an indefinite period until the subject withdraws his/her consent.",
            "The purpose of processing specified by the Controller is to use the personal data solely for the possible establishment of business cooperation with the data subject.",
            "The Controller declares that personal data will be collected only to the extent necessary to fulfil the purposes stated above and processed solely for the purpose for which it was collected. The data will be processed: a) mechanically (automatically), using computers and software within the information system; and b) manually.",
            "This consent is a free and informed expression of my will. I understand that I may withdraw it at any time. This does not affect the Controller's right to process personal data where processing is necessary to provide a service, perform a contract or comply with applicable law.",
            "I also confirm that I have been informed about and understand the Controller's privacy policy.",
        ]
    },
    ka: {
        title: "პერსონალური მონაცემების დამუშავება",
        parag: [
            'პერსონალური მონაცემების დაცვის მიზნით, როგორც მონაცემთა სუბიექტი, თანახმა ვარ ჩემი პერსონალური მონაცემების შეგროვებაზე, შენახვასა და დამუშავებაზე: სახელი, გვარი, ელფოსტის მისამართი, საცხოვრებელი მისამართი, დაბადების თარიღი, მობილური ტელეფონის ნომერი, უმაღლესი განათლების შესახებ მონაცემები და სხვა ინფორმაცია. გამოგზავნილი კითხვარი ნებაყოფლობით შევავსე და ამით ვუთითებ პერსონალურ მონაცემთა ადმინისტრატორს: Tresher s.r.o., მისამართით პრაღა - Na Maninách 1040/14, Holešovice (პრაღა 7), 170 00 პრაღა, საიდენტიფიკაციო ნომერი 24217280, დღგ-ს ნომერი CZ24217280, რეგისტრირებული პრაღის სასამართლოში, საქმის ნომერი 189598 C. (შემდგომში „ადმინისტრატორი“).',
            "ეს თანხმობა გაცემულია განუსაზღვრელი ვადით, სანამ პირი არ გააუქმებს თავის თანხმობას.",
            "ადმინისტრატორის მიერ განსაზღვრული პერსონალური მონაცემების დამუშავების მიზანი, რისთვისაც მონაცემთა სუბიექტი იძლევა ამ თანხმობას, არის პერსონალური მონაცემების გამოყენება მხოლოდ მონაცემთა სუბიექტთან შესაძლო საქმიანი თანამშრომლობის დასაწყებად.",
            "ადმინისტრატორი აცხადებს, რომ პერსონალურ მონაცემებს შეაგროვებს ზემოაღნიშნული მიზნის შესასრულებლად საჭირო მოცულობით და დაამუშავებს მხოლოდ იმ მიზნის შესაბამისად, რისთვისაც ისინი შეგროვდა. ადმინისტრატორი აცხადებს, რომ პერსონალურ მონაცემებს დაამუშავებს შემდეგნაირად: ა) მექანიკურად (ავტომატურად), კომპიუტერებითა და კომპიუტერული პროგრამებით ინფორმაციული სისტემის ფარგლებში; ბ) ხელით.",
            "ეს თანხმობა მონაცემთა სუბიექტის თავისუფალი და გაცნობიერებული ნების გამოხატულებაა, რომლის შინაარსიც არის ჩემი, როგორც სუბიექტის, თანხმობა ზემოაღნიშნული პერსონალური მონაცემების დამუშავებაზე. ვიცი, რომ ამ თანხმობის გაუქმება ნებისმიერ დროს შემიძლია. ეს არ ეხება ადმინისტრატორის (ან საქმის მწარმოებლის) უფლებას, დაამუშავოს პერსონალური მონაცემები, თუ მათი გამოყენება საჭიროა მომსახურების გასაწევად ან ხელშეკრულების შესასრულებლად და კანონით დაშვებულ ფარგლებში.",
            "ასევე ვადასტურებ, რომ გავეცანი და ვიცნობ ადმინისტრატორის პერსონალური მონაცემების დაცვისა და დამუშავების პრინციპებს.",
        ],
    },
}

export {
    faqData,
    dataProcessing,
};
